import { Button, Tooltip, TooltipTrigger } from '@toggle/design-system';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useTouchDevice } from '~/hooks/MediaQueryHook';

import styles from './NewChatButton.module.scss';

interface NewChatButtonProps {
  className?: string;
  iconOnly?: boolean;
  isHistoryExpanded?: boolean;
  onClick?: () => void;
}

export const NewChatButton: FC<NewChatButtonProps> = ({
  onClick,
  iconOnly = false,
  className,
  isHistoryExpanded = false,
}) => {
  const { t } = useTranslation(['chat']);
  const isTouchDevice = useTouchDevice();

  return (
    <Tooltip
      label={t('chat:historySidebar.newConversation')}
      disabled={isHistoryExpanded || isTouchDevice}
      trigger={TooltipTrigger.Hover}
      placement="right"
    >
      <Button
        className={clsx(styles.styledButton, className)}
        variant={'tertiary'}
        size={isTouchDevice ? 'large' : 'small'}
        iconName="ChatNew"
        label={iconOnly ? undefined : t('chat:historySidebar.newConversation')}
        onClick={onClick}
      />
    </Tooltip>
  );
};
